<body>
<router-outlet></router-outlet>
</body>
<!-- Footer Area Start -->

